import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import ModalCliente from './ModalCliente/ModalCliente'
import ModalAssocOperadorLogistico from './ModalAssocOperadorLogistico/ModalAssocOperadorLogistico'
import ModalAssocEmpresa from './ModalAssocEmpresa/ModalAssocEmpresa'
import ModalClienteTrecho from './ModalClienteTrecho/ModalClienteTrecho'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalAssocRotaEntrega from './ModalAssocRotaEntrega/ModalAssocRotaEntrega'
import useCliente, { LOAD_MESSAGE, MENU_ITEMS_NAMES, MODAL_NAME } from './ClienteHook'

function Cliente({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useCliente()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.LOADING_CUSTOMERS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCustomers(selectedTp)
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const buildDataTable = () => {
    const header = (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, width: '100%' }}>
        <div style={{ textAlign: 'left' }}>
          <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
          <InputText
            type="search"
            onInput={e => localDispatch.onInputFilter(e.target.value)}
            placeholder="Pesquisar . . ."
            size="50"
          />
        </div>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.customers)}>Exportar</Btn>
      </div>
    )
    return (
      <DataTable
        value={state.customers}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
      >
        <Column field="nomeFantasia" header="Nome Fantasia" />
        <Column
          field="cnpj"
          header="CNPJ/CPF"
          body={(customer, column) => <Cnpj>{customer.cnpj}</Cnpj>}
        />
        <Column field="district" header="Bairro" />
        <Column field="city" header="Cidade" />
        <Column field="state" header="Estado" />
        <Column
          field="actived"
          header="Ativo"
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => <CustomCheckbox disabled checked={rowData.actived} />}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={customer => (
            <ThreeDots
              items={MENU_ITEMS_NAMES}
              onClick={item => localDispatch.onMenuItemClicked(item, customer)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
    )
  }

  return (
    <div>
      <PageHeader>2.1 - Clientes</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovoCliente(selectedTp)}
          onVoltar={() => history.goBack()}
        >
          {buildDataTable()}
        </CustomPanel>
      </div>
      {localDispatch.modalIsOpen(MODAL_NAME.CUSTOMER) && (
        <ModalCliente
          show={true}
          onModalClose={localDispatch.closeModal}
          onModalSave={localDispatch.onModalClienteSave}
          selectedCliente={
            state.modalHandler.modalData ? { ...state.modalHandler.modalData } : null
          }
        />
      )}
      <ModalAssocOperadorLogistico
        show={localDispatch.modalIsOpen(MODAL_NAME.ASSOC_CUSTOMER_LOG_OPERATOR)}
        onModalClose={localDispatch.closeModal}
        customer={state.modalHandler.modalData}
      />
      <ModalAssocEmpresa
        show={localDispatch.modalIsOpen(MODAL_NAME.ASSOC_CUSTOMER_ENTERPRISE)}
        onModalClose={localDispatch.closeModal}
        customer={state.modalHandler.modalData}
      />
      <ModalClienteTrecho
        show={localDispatch.modalIsOpen(MODAL_NAME.CUSTOMER_STRETCH)}
        onModalClose={localDispatch.closeModal}
        customer={state.modalHandler.modalData}
      />
      <ModalAssocRotaEntrega
        onClose={localDispatch.closeModal}
        isVisible={localDispatch.modalIsOpen(MODAL_NAME.DELIVERY_ROUTE)}
        customer={state.modalHandler.modalData}
        selectedTp={selectedTp}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Cliente))
